<template>
    <div>
        <p class="warning-message" v-if="(maxUsdSlippage > 1000)">
            With your current Max Slippage setting ({{ slippage }}%), the expected output displayed above might incur up to <b>${{ formatLargeNumber(maxUsdSlippage, 0) }} worth of slippage</b> (in addition to the price impact). We recommend that you reduce your Max Slippage setting<span v-if="maxSlippageSettingUiPosition === 'top'"> just above</span><span v-else>, under “Advanced Options”</span>.
        </p>
    </div>
</template>

<script>
import { getters, contract as currentContract } from '../../contract';
import { blockchainId } from '@/constants/config';
import { truncWithXSignificantDecimals, formatLargeNumber } from '@/utils/Number';
import { lc } from '@/utils/String';
import getAllCurvePoolsData from '@/utils/data/curve-pools-data';

export default {
    props: [
        'slippage',
        'amount',
        'address',
        'maxSlippageSettingUiPosition',
    ],
    data: () => ({
        allCurvePoolsData: undefined,
    }),
    async mounted() {
        this.allCurvePoolsData = await getAllCurvePoolsData(blockchainId);
    },
    methods: {
        formatLargeNumber,
        getCoinUsdPrice(coinAddress) {
            const lcCoinAddress = lc(coinAddress);

            const pools = this.allCurvePoolsData || [];
            const lpTokenPool = pools.find(({ lpTokenAddress, address }) => (
                lcCoinAddress === lc(lpTokenAddress || address)
            ));
            const isLpTokenAddress = typeof lpTokenPool !== 'undefined';

            if (isLpTokenAddress) {
                const lpTokenPrice = lpTokenPool.usdTotal / (lpTokenPool.totalSupply / 1e18);
                return lpTokenPrice;
            } else {
                return (
                    pools.filter(({ coins }) => (
                        coins.some(({ address }) => lc(address) === lcCoinAddress)
                    )).sort(({ usdTotal: usdTotalA }, { usdTotal: usdTotalB }) => (
                        usdTotalA > usdTotalB ? -1 :
                            usdTotalA < usdTotalB ? 1 : 0
                    ))[0]?.coins?.find(({ address }) => lc(address) === lcCoinAddress)?.usdPrice
                );
            }
        },
    },
    computed: {
        maxUsdSlippage() {
            const usdPrice = this.getCoinUsdPrice(this.address);
            if (typeof usdPrice === 'undefined') return undefined;

            return this.amount * usdPrice * (this.slippage / 100);
        },
    },
}
</script>
